export default {
  placeholders: {
    flagMessage: "Flag Message",
    searchAdset: "Search Adset",
    startTyping: "Start typing...",
    selectDate: "Select date",
    descriptionEn: "English Description",
    descriptionAr: "Arabic Description",
    doAndDontEn: "English Do and Don`t",
    doAndDontAr: "Arabic Do and Don`t",
    websiteURLEn: "English Website URL",
    websiteURLAr: "Arabic Website URL",
    creativesURLEn: "English creatives URL",
    creativesURLAr: "Arabic creatives URL",
    doEn: "Do English",
    doAr: "Do Arabic",
    dontEn: "Don`t English",
    dontAr: "Don`t Arabic",
    partnerSearchCriteria: "Search by name, email, ID, phone, social media, traffic source, IBAN, account number or account holder name",
    promotionDescriptionEn: "Promotion Description English",
    promotionDescriptionAr: "Promotion Description Arabic",
    operatingCountriesPlaceholder: "Select one or more countries",
    operatingCategoriesPlaceholder: "Select one or more categories",
    enterFlagMessage: "Enter Flag Message",
    editOrAddNewNotes: "Please edit or add new notes",
    validationComment: "Validation comment",
    addReasonOfRevokement: "add reason for revokement",
    insertNetworkName: "Insert network name",
    URLName: "Enter URL Name",
    comment: "Comment",
    howYouWillPromote: "How you will promote",
    rejectionReason: "Reason of rejection",
    firstName: "First name",
    lastName: "Last name",
    countryOfResidence: "Country of residence",
    nationality: "Nationality",
    phoneNumber: "Phone number",
    verificationCode: "",
    budgetCapLimit: "Budget Cap Limit",
    conversionCapLimit: "Conversion Cap Limit",
    whatsapp: "WhatsApp number",
    instagram: "Instagram username ",
    twitter: "Twitter username",
    facebook: "facebook username",
    snapchat: "Snapchat username",
    tiktok: "Tiktok username",
    telegram: "telegram username",
    youtube: "youtube username",
    commentsInput: "Write a comment",
    bankTransfer: "Bank Transfer",
    city: "City",
    branch: "Branch",
    iban: "IBAN",
    swift: "Swift",
    paypal: "PayPal",
    mobileCash: "Mobile Cash",
    bankName: "Bank Name",
    accountHolderName: "Account Holder Name",
    mobileCashProvider: "Mobile Cash Provider",
    mobileCashId: "Mobile Cash ID",
    email: "Email",
    otherAffiliateNetworks: "Other publisher networks",
    yearsOfExperience: "Years of experience",

    rateDetails: "Rate details",
    reference: "Reference",
    agentName: "Agent name",
    agentContact: "Agent contact",
    notes: "Notes",

    address: "Address",
    companyName: "Company Name",
    websiteLink: "Website Link",
    skypeAccount: "Skype Account",

    arabyadsReference: "Arabyads Reference",
    affiliateNetworks: "Publisher Networks",
    yearsAsAffiliate: "Years as publisher",
    linkedIn: "Linkedin username",
    pintrest: "Pintrest username",
    whatsApp: "WhatsApp username",
    tikTok: "Tiktok username",
    native: "Native",
    social: "Social",
    other: "Other",
    display: "Display",
    video: "Video",
    search: "Search",
    others: "Others",
    bankCity: "City",
    bankBranch: "Branch",
    bankHolderName: "Holder Name",
    affiliateYearsOfExperience: "Publisher years of experience",
    mobileApp: "Mobile App",
    pinterest: "Pinterest username",
    youTube: "Youtube username",
    website: "Website",
    enterTheEmailDataCollectionSource: "enter the email data collection source",
    specifyThePlatformYouUse: "Specify the platform you use",

    typeSubjectHere: "Type subject here",
    addContentLink: "Add content link",
    searchPartners: "Search partners",
    writeDownYourValidationNote: "Write down your validation note",

    accountNumber: "Account Number",

    addAdvertiserName: "Add advertiser name",
    addAdvertiserEmail: "Add advertiser email",
    noDateSelected: "No date selected",
    clientContactName: "Client Contact Name",
    clientContactEmail: "Client Contact Email",
    addClientContactName: "Add Client Contact Name",
    addClientContactEmail: "Add Client Contact Email",
    typeSuspensionReason: "Type suspension reason",

    sendMessage: "Send a message",
    name: "Name",
    description: "Description",
    categoriesList: "Categories",
    spend: "Spend",
    off: "% Off",
    enterValue: "Enter Value",
    promotion: "Promotion",
    typeAccountDeletionReason: "Type account deletion reason",
    zero: "0",
    oldPassword: "Old Password",
    newPassword: "New Password",
    newPasswordConfirmation: "Confirm New Password",
    partnerCode: "Partner Code",
    sevenDays: "7 Days",
    thirtyDays: "30 Days",
    offerUrl: "Enter offer URL",
    userSource: "User Source",
    userClickId: "User Click ID",
    sub1: "Sub ID 1",
    sub2: "Sub ID 2",
    sub3: "Sub ID 3",
    sub4: "Sub ID 4",
    sub5: "Sub ID 5",
    commission: "Commission",
    capAmount: "Cap Amount",
    from: "From",
    to: "To",
    value: "Value",

    tipDescriptionEn: "English Description",
    tipDescriptionAr: "Arabic Description",
    deepLink: "Deep Link",
    advertiserSentLink: "Advertiser sent link",
    defaultDeepLinkURL: "Default Deeplink URL",
    agencyAdminName: "Agency admin name",
    agencyName: "Agency Name",
    websiteURL: "Website URL",
    lastYearRevenue: "Last year revenue USD",
    comments: "comments",
    enterBrandName: "Enter brand name",
    paymentCycle: "Payment Cycle",
    addComment: "Add comment...",
    addRedirectionLink: "Please add redirection link",
    addReason: "Add Reason...",
    addReasonOfRejection: "Add reason of rejection...",
    boostinyLink: "Boostiny Link",
    numOfDaysBetween: "Number of days (between 1 and 30)",
    payoneer: "Payoneer",
    addReasonOfUndo: "Add reason of undo...",
    startInvoicingNumber: "Start invoicing number",
    exchangeRate: "Exchange rate",
    companyWebsite: "Company Website",
    username: "Username",
    url: "URL",
    addAppLink: "Add app link",
    enterMessage: "Enter message",
    selectPublisherType: "Select publisher type",
    paypalAccount: "Paypal Account",
    payoneerAccount: "Payoneer Account",
    selectTargetMonth: "Select target month",
  },
}
